<template>
<footer class="py-4 bg-dark">
  <div class="container">
    <div class="row border-bottom border-primary">
      <div class="col-lg-4">
        <img src="/assets/images/logo.png" alt="Logo" style="max-width: 120px;">
        <p class="text-white mt-2">
          Lorem ipsum, dolor sit amet consectetur adipisicing elit. Facilis ullam, minus molestias, magni excepturi repellendus perspiciatis numquam nesciunt obcaecati dolore iure pariatur atque, vel aliquid architecto! Ullam fuga repudiandae mollitia.
        </p>
      </div>
      <div class="col-lg-8">
        <div class="row">
          <div class="col-lg-4">
        <h3 class="text-white">Footer Content</h3>
        <ul class="p-0">
          <li class="mb-2">
            <a href="#" class="text-info text-decoration-none">Footer Link</a>
          </li>
          <li class="mb-2">
            <a href="#" class="text-info text-decoration-none">Footer Link</a>
          </li>
          <li class="mb-2">
            <a href="#" class="text-info text-decoration-none">Footer Link</a>
          </li>
          <li class="mb-2">
            <a href="#" class="text-info text-decoration-none">Footer Link</a>
          </li>
          <li class="mb-2">
            <a href="#" class="text-info text-decoration-none">Footer Link</a>
          </li>
          <li>
            <a href="#" class="text-info text-decoration-none">Footer Link</a>
          </li>
        </ul>
      </div>
      <div class="col-lg-4">
        <h3 class="text-white">Footer Content</h3>
        <ul class="p-0">
          <li class="mb-2">
            <a href="#" class="text-info text-decoration-none">Footer Link</a>
          </li>
          <li class="mb-2">
            <a href="#" class="text-info text-decoration-none">Footer Link</a>
          </li>
          <li class="mb-2">
            <a href="#" class="text-info text-decoration-none">Footer Link</a>
          </li>
          <li class="mb-2">
            <a href="#" class="text-info text-decoration-none">Footer Link</a>
          </li>
          <li class="mb-2">
            <a href="#" class="text-info text-decoration-none">Footer Link</a>
          </li>
          <li>
            <a href="#" class="text-info text-decoration-none">Footer Link</a>
          </li>
        </ul>
      </div>
      <div class="col-lg-4">
        <h3 class="text-white">Footer Content</h3>
        <ul class="p-0">
          <li class="mb-2">
            <a href="#" class="text-info text-decoration-none">Footer Link</a>
          </li>
          <li class="mb-2">
            <a href="#" class="text-info text-decoration-none">Footer Link</a>
          </li>
          <li class="mb-2">
            <a href="#" class="text-info text-decoration-none">Footer Link</a>
          </li>
          <li class="mb-2">
            <a href="#" class="text-info text-decoration-none">Footer Link</a>
          </li>
          <li class="mb-2">
            <a href="#" class="text-info text-decoration-none">Footer Link</a>
          </li>
          <li>
            <a href="#" class="text-info text-decoration-none">Footer Link</a>
          </li>
        </ul>
      </div>
        </div>
      </div>
    </div>
    <p class="mt-3 mb-0 text-center text-white fw-bolder">
      DEVELOPED BY <span class="text-success">Vue3</span>
    </p>
  </div>
</footer>
</template>
<script>
    export default {
        name : "FooterComponent"
    }
</script>
<style>
</style>